import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { GroupService } from "../../admin/services/group.service";
import { GroupStub } from "../../admin/models/group.model";

import { Contact, AgentType, AgentTypeOptions } from "../../admin/models/contact.model";

@Injectable()
export class EmailConfigService {

    defaultAddressOption = { id: "-1", displayName: "..." };
    otherAddressOption = { id: "other", displayName: "Other" };

    constructor(public readonly groupService: GroupService) {

    }

    getAddressOptions(includeOther: boolean): Promise<Array<any>> {
        return (this.groupService.get({ stubs: true }) as Observable<GroupStub[]>).toPromise()
            .then(groups => {
                let addressOptions = new Array<any>();
                addressOptions.push(this.defaultAddressOption);
                groups.forEach(g => {
                    g.id = `group|${g.id}`;
                    g.displayName = `Group - ${g.displayName}`;
                    addressOptions.push(g);
                });
                addressOptions = addressOptions.concat(this.getContacts());
                if (includeOther) {
                    addressOptions.push(this.otherAddressOption);
                }
                addressOptions.sort((a, b) => {
                    return this.addressOptionSort(a, b);
                });
                return addressOptions;
            });
    }

    public getContacts(): Array<any> {
        const addressOptions = new Array<any>();
        AgentTypeOptions.All.forEach(a => {
            addressOptions.push({ id: `contact|${a.id}`, displayName: `Contact Type - ${a.text}` });
        });
        return addressOptions;
    }

    public addressOptionSort(a: any, b: any): number {
        let comparison: number = 0;
        const aIdParts = a.id.split("|");
        const bIdParts = b.id.split("|");
        if (aIdParts[0] === "-1") { //the default option should always be first
            comparison = -1;
        } else if (aIdParts.length > bIdParts.length) { //the group and contact options should always come before other
            comparison = -1;
        } else if (aIdParts.length < bIdParts.length) {
            comparison = 1;
        } else if (aIdParts.length === bIdParts.length) {
            if (aIdParts[0] > bIdParts[0]) { //put contacts before groups
                comparison = 1;
            } else if (aIdParts[0] < bIdParts[0]) {
                comparison = -1;
            } else if (aIdParts[0] === bIdParts[0]) { //sort within contacts or groups by display name 
                if (a.displayName > b.displayName) {
                    comparison = 1;
                } else if (a.displayName < b.displayName) {
                    comparison = -1;
                }
            }
        }
        return comparison;
    }
}